<template>
  <div class="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    ></BlockUI>

    <v-card>
      <v-card-title>
        Pacotes Vendidos
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <div class="search-bar">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Procurar"
            single-line
            hide-details
          ></v-text-field>
        </div>
        <div class="filter">
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="formatedBeginDate"
                label="Data inicial"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="begin_date"
              locale="pt-br"
              scrollable
              @input="menu1 = false"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="
                  menu1 = false;
                  begin_date = null;
                "
              >
                Limpar
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="formatedEndDate"
                label="Data final"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="end_date"
              locale="pt-br"
              scrollable
              @input="menu2 = false"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="
                  menu2 = false;
                  end_date = null;
                "
              >
                Limpar
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-btn depressed @click="getPackagesSold">
            <v-icon>mdi-filter</v-icon>
            Filtrar
          </v-btn>
        </div>
      </v-card-text>
      <br />
      <v-data-table
        no-data-text="Nenhum dado encontrado para a data escolhida"
        no-results-text="Nenhum dado encontrado para a data escolhida"
        :headers="headers"
        :items="data"
        :search="search"
        item-key="name"
        class="elevation-1"
        :items-per-page="15"
        :footer-props="{
          'items-per-page-text': 'Linhas por página:',
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.activations }}</td>
            <td>
              <v-icon small @click="showVehicleRequestsDetails(item)">
                mdi-open-in-new
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="showVehicleRequestsDialog" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >Pacotes Vendidos pelo Cliente "{{
              clientExpanded ? clientExpanded.name : ''
            }}" <br v-if="begin_date" />{{
              begin_date ? ` em ${formatedBeginDate}` : ''
            }}{{ end_date ? ` - ${formatedEndDate}` : '' }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="vehicleRequestsHeaders"
            :items="vehicleRequestsData"
            :search="searchVehicleRequests"
            :items-per-page="15"
            :footer-props="{
              'items-per-page-text': 'Linhas por página:',
              'items-per-page-options': [15, 30, 50, 100],
            }"
            no-data-text="Nenhuma reserva com pacote encontrada"
            no-results-text="Nenhuma reserva com pacote encontrada"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-text-field
                v-model="searchVehicleRequests"
                label="Procurar"
                class="mx-4"
              ></v-text-field>
            </template>
            <template v-slot:item.begin_date="{ item }">
              {{ formatDateTime(item.begin_date) }}
            </template>
            <template v-slot:item.end_date="{ item }">
              {{ formatDateTime(item.end_date) }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showVehicleRequestsDialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import DateHelper from '../../helpers/DateHelper';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import VehicleRequestController from '../../controllers/VehicleRequestController';

export default {
  data() {
    return {
      clientExpanded: null,
      showVehicleRequestsDialog: false,
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      data: [],
      vehicleRequestsData: [],
      search: '',
      searchVehicleRequests: '',
      begin_date: null,
      end_date: null,
      menu1: false,
      menu2: false,
      headers: [
        { text: 'Cliente', value: 'name' },
        { text: 'Pacotes Vendidos', value: 'activations' },
        { text: '' },
      ],
      vehicleRequestsHeaders: [
        { text: 'Placa', value: 'vehicle.plate' },
        { text: 'Usuário', value: 'user.name' },
        { text: 'Status', value: 'step.title' },
        { text: 'Check-In', value: 'begin_date' },
        { text: 'Check-Out', value: 'end_date' },
        { text: 'Promoção', value: 'promotion.name' },
        { text: 'Tipo', value: 'promotion.type' },
      ],
    };
  },

  created() {
    this.vehicleRequestController = new VehicleRequestController(
      this.$resource
    );

    this.getPackagesSold();
  },

  methods: {
    async getPackagesSold() {
      this.blockScreen = true;

      if (!this.begin_date && this.end_date) {
        this.$awn.alert('A data inicial não foi escolhida!');
        this.blockScreen = false;
        return;
      }

      try {
        this.data = await this.vehicleRequestController.getPromotionsByClient(
          this.begin_date,
          this.end_date
        );
      } catch (error) {
        this.$awn.alert('Falha ao obter os pacotes vendidos por cliente');
        console.log(error);
      } finally {
        this.blockScreen = false;
      }
    },

    async showVehicleRequestsDetails(client) {
      this.blockScreen = true;
      this.clientExpanded = client;
      this.vehicleRequestsData = await this.vehicleRequestController.getVehicleRequestsWithPromotionByClientId(
        client.client_id,
        this.begin_date,
        this.end_date
      );
      this.searchVehicleRequests = '';
      this.blockScreen = false;
      this.showVehicleRequestsDialog = true;
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },

    formatDateTime(dateTime) {
     return moment(dateTime).format('DD[/]MM[/]YYYY HH:mm');
    },
  },

  computed: {
    formatedBeginDate: function () {
      if (!this.begin_date) return null;
      return this.formatDate(this.begin_date);
    },

    formatedEndDate: function () {
      if (!this.end_date) return null;
      return this.formatDate(this.end_date);
    },
  },
};
</script>

<style scoped lang="scss">
.search-bar {
  display: flex;
  flex: 1;
}

.filter {
  display: flex;
  justify-content: center;
  align-items: center;

  .v-input {
    margin-right: 80px;
  }
}
</style>
